import checkbox from './checkbox.vue'

export default checkbox
